import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { NotificationService } from '../../../../app.common/modules/common/services/notification.service';
import { IPaginationStoresFilter } from '../../api';
import { RetailerService } from '../../api/retailer.service';
import { StoreListItem } from '../../core';
import { ShopService } from '../../places/shop.service';

export interface ILocationModel  extends StoreListItem {
    IsSelected?: boolean;
}

class SelectLocations implements ng.IController {

    public static $inject = [
        'notificationService',
        'retailerService',
        'shopService'
    ];

    public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;

    public model = {
        location: null as ILocationModel,
        searchTerm: null as string,
        waiting: false as boolean
    };
    public locations: ILocationModel[] = [];
    public total: number = 0;

    public resolve: {
        options: {
            selectedLocationID: number,
            fullName: boolean,
            onlyWithoutPrinter: boolean
        }
    };

    constructor(
        private notificationService: NotificationService,
        private retailerService: RetailerService,
        private shopService: ShopService
    ) {
    }

    public async $onInit() {
        await this.loadLocations();
    }

    public loadLocations() {
        const selectedLocation = this.resolve.options.selectedLocationID ? {
            ID: this.resolve.options.selectedLocationID
        } : null;

        if (this.model.waiting) {
            return;
        }

        if ( this.total && this.locations.length === this.total) {
            return;
        }

        const filter : IPaginationStoresFilter = {
            active: true,
            storeName: this.model.searchTerm,
            limit: 10,
            offset: this.locations.length,
            sortColumn: '',
            sortOrder: ''
        };

        if (this.resolve.options.onlyWithoutPrinter != null) {
            filter.onlyWithoutPrinter = this.resolve.options.onlyWithoutPrinter;
        }

        this.model.waiting = true;
        this.notificationService.showWaitingMessage();

        return this.shopService
            .getStores(filter)
            .then((response: any) => {
                this.total = response.Total;
                const locations: StoreListItem[] = response.Items;

                Array.prototype.push.apply(this.locations, locations);

                if (selectedLocation) {
                    const foundLocation = locations.find((location) => location.ID === selectedLocation.ID);
                    if (foundLocation) {
                        this.model.location = foundLocation;
                    }
                }

                if (this.model && this.model.location) {
                    const foundLocation = locations.find((location) => location.ID === this.model.location.ID);
                    if (foundLocation) {
                        this.model.location = foundLocation;
                    }
                }

                this.model.waiting = false;
            })
            .catch((e) => this.notificationService.showErrorMessage(e))
            .finally(() => this.notificationService.clearAll());
    }

    public searchKeyPressed($event: KeyboardEvent) {
        if ($event.which === 13 && !this.model.waiting) {
            this.search(this.model.searchTerm);
        }
    }

    public confirm() {
        const selectionResult = {
            status: 'ok',
            selectedLocation: {} as ILocationModel
        };

        selectionResult.selectedLocation = this.model.location;
        this.modalInstance.close( { $value: selectionResult});
    }

    public search(text: string) {
        this.total = 0;
        this.locations = [];
        this.model.searchTerm = text;
        this.loadLocations();
    }

    public resetSearch() {
        this.model.searchTerm = '';
        this.locations = [];
        this.search(this.model.searchTerm);
    }

    public getLogoUrl(iconId: number): string {
        return this.retailerService.getStoreLogoUrl(iconId, 48, 48);
    }

    public dismiss = () => this.modalInstance.close({$value: {status: 'close'}});
}

angular.module('naut').component('selectSingleLocation', {
    template: require('./select-single-location.component.html'),
    controller: SelectLocations,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/shared/select-single-location/select-single-location.component.ts